import { Accordion, AccordionItem, ControlledAccordion, useAccordionProvider } from '@szhsin/react-accordion'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router'
import { GlobalContext } from '../../global/GlobalProvider';
import config from '../../config';
import StackUpdate from '../../components/StackUpdate';
import ChangePassword from '../../components/ChangePassword';
import UpcommingFixture from '../UpcommingFixture';
import StackUpdateFixedBox from '../../components/StackUpdateFixedBox';
import { useTranslation } from 'react-i18next';
import SettingPopup from '../SettingPopup';
import Notification from '../Notification';

function HeaderMain() {
  const { t, i18n } = useTranslation();

  const providerValue = useAccordionProvider({
    allowMultiple: true,
    transition: true,
    transitionTimeout: 250
  });

  // Destructuring `toggle` and `toggleAll` from `providerValue`
  const { toggle, toggleAll } = providerValue;
  const { setTelegramPop,telegamPopupOpen, setLoginPop,isLoggedIn, loggedIn, isLoggedOut, setAlertMsg, openSuccessPopup, openErrorPopup, setLoading, setStackList, setMobileMenu,isMobileMenuOpen,setCurrentTheme } = useContext(GlobalContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isOpenProfile1, setIsOpenProfile1] = useState(false);
  const [isOpenProfile2, setIsOpenProfile2] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isStackOpen, setStackOpen] = useState(false);
  const accordionRef1 = useRef(null);
  const accordionRef2 = useRef(null);
  const [totalExposure, setTotalExposure] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [bonus, setBonus] = useState(0);
  const initialized = useRef(false);
  const [isPasswordChange, setIsPasswordChange] = useState(() => {
    const storedValue = sessionStorage.getItem('passwordchanged');
    return storedValue === "true";
  });
  const location = useLocation();
  const [changePassword, setChangePassword] = useState(false);
  useEffect(() => {
    if (isLoggedIn || loggedIn) {
      setIsPasswordChange(sessionStorage.getItem('passwordchanged') === "true")
      if (sessionStorage.getItem('passwordchanged') === "true") {
        setChangePassword(true)
        // console.log("password Not Updated")
      } else {
        // console.log("Password Updated")
      }
    }
  }, [isPasswordChange, isLoggedIn, loggedIn])
  useEffect(() => {

        }, [location]);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getStackListAPI();
    }
  }, []);

  const toggleAccordion1 = () => {
    setIsOpenProfile1((prev) => {
      const newState = !prev;
      toggle('item-1', newState); // Ensure correct toggle
      return newState;
    });
  };
  
  const toggleAccordion2 = () => {
    setIsOpenProfile2((prev) => {
      const newState = !prev;
      toggle('item-2', newState); // Use different IDs
      return newState;
    });
  };
  
  const handleMobileLogin = () =>{
    setLoginPop(true);
  }

  const handleLogin = () => {
    let isValid = true;

    // Validate Username
    if (!username.trim()) {
      openErrorPopup();
      setAlertMsg("Username cannot be empty!");
      isValid = false;
      return;
    } else {
      setAlertMsg(""); // Clear error if valid
    }

    // Validate Password
    if (!password.trim()) {
      openErrorPopup();
      setAlertMsg("Password cannot be empty!");
      isValid = false;
      return;
    } else {
      setAlertMsg(""); // Clear error if valid
    }

    if (isValid) {
      setLoading(true);
      const loginData = {
        userName: username,
        password: password,
        whiteLabelName: config.WhiteLable
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/userLoginworld`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      }).then((response) => response.json())
        .then((data) => {
          setLoading(false);
          console.log("Login success:", data);
          if (data.token && data.user && data.sessionId) {
            if (data.user.issecureauthenable &&  data.user.isconnectedtochannal) {
                setLoading(false);
                config.userData = data;
                setLoginPop(false);
                setTelegramPop(true);
                setUsername("");
                setPassword("");
                // <OTPVerifyPopup data={data} />
              }else{
                setLoading(false);
                sessionStorage.setItem("token", data.token);
                sessionStorage.setItem("sessionId", data.sessionId);
                sessionStorage.setItem("userinfo", JSON.stringify(data.user));
                sessionStorage.setItem("issecureauthenable", data.user?.issecureauthenable ? data.user?.issecureauthenable : false);
                sessionStorage.setItem("userId", data.user._id)
                sessionStorage.setItem("loggedIn", "true");
                sessionStorage.setItem('isOneClicked', data?.user?.oneclickstatus)
                sessionStorage.setItem('oneClickAmount', data?.user?.oneclickstack)
                sessionStorage.setItem('passwordchanged', data?.user?.passwordchanged)
                isLoggedIn();
                openSuccessPopup();
                setAlertMsg("Login Successful!");
                setUsername("");
                setPassword("");
                isLoggedIn();
                window.location.replace(`${config.isWhiteLabel ? '/sport' :'/'}`);
              }
          } else {
            setAlertMsg(data.message)
            openErrorPopup();
          }
        })
        .catch((error) => {
          setLoading(true);
          console.error("Error:", error);
          // Handle login error
        });
    }
  };

  const demoHandleClick = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/userLoginworld`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: "Demo" }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        // console.log('Login success:', data);
        if (data.token && data.user && data.sessionId) {
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("sessionId", data.sessionId);
          sessionStorage.setItem("userinfo", JSON.stringify(data.user));
          sessionStorage.setItem("issecureauthenable", data.user?.issecureauthenable ? data.user?.issecureauthenable : false);
          sessionStorage.setItem("userId", data.user._id)
          sessionStorage.setItem("loggedIn", "true");
          isLoggedIn();
          window.location.replace(`${config.isWhiteLabel ? '/sport' :'/'}`);
          openSuccessPopup();
          setAlertMsg("Login Successful!");
          setUsername("");
          setPassword("");
          isLoggedIn();
        } else {
          setAlertMsg(data.message)
          openErrorPopup();
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };


  const handleLogout = (flag) => {
    // setIsOpenProfile1(false);
    // toggle('item-1', false);
    // setIsOpenProfile2(false);
    // toggle('item-2', false);
    localStorage.setItem('bannerOpen',false)
    config.bannerOpen = false;
    const token = sessionStorage.getItem('token');

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/logOutworld`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
    
    getStackListAPI();
    openSuccessPopup();
    setAlertMsg("Logout Successful!");
    if (flag) {
      setTimeout(() => {
        isLoggedOut();
        navigate("/sport");
        sessionStorage.clear();
      }, 500);
    }

  };

  const getStackListAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (sessionStorage.getItem("token")) {
      myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
    }

    const raw = JSON.stringify({
      whiteLabelName: config.WhiteLable,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/getStakeLabes2`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        sessionStorage.setItem("stackList", JSON.stringify(paresData.data))
        setStackList(JSON.stringify(paresData.data))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClickOutside = (event) => {
    console.log('Clicked:', event.target);
  
    if (accordionRef1.current && !accordionRef1.current.contains(event.target)) {
      console.log('Closing accordion 1');
      setIsOpenProfile1(false);
      toggle('item-1', false);
    }
  
    if (accordionRef2.current && !accordionRef2.current.contains(event.target)) {
      console.log('Closing accordion 2');
      setIsOpenProfile2(false);
      toggle('item-2', false);
    }
  };
  

  const handleClickOutside2 = (event) => {
    if (accordionRef2 && accordionRef2.current && !accordionRef2.current.contains(event.target)) {
      setIsOpenProfile2(false);
    }
};

useEffect(() => {
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isOpenProfile1, isOpenProfile2]); // Add dependencies to track changes

  useEffect(() => {
    if (loggedIn || sessionStorage.getItem('loggedIn')) {
      callIsLogin();
      callWallet();

      const intervalId1 = setInterval(callIsLogin, 5000);
      const intervalId2 = setInterval(callWallet, 5000);

      return () => {
        clearInterval(intervalId1);
        clearInterval(intervalId2);
      };
    }
  }, [loggedIn]);

  const callIsLogin = () => {
    if (sessionStorage.getItem('loggedIn') || loggedIn) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/logInCheck`, requestOptions)
        .then(async (response) => {
          // console.log("logInCheck - ", response);
          let paresData = await response.json();
          if (paresData.isLogout) {
            handleLogout(true);
          }
        })
        .catch((error) => {
          // console.log("logInCheck - ",error);
        });
    }
  };

  const callWallet = () => {
    if (sessionStorage.getItem('loggedIn') || loggedIn) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };
      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/Account/getexposure`, requestOptions)
        .then(async (response) => {
          let paresData = await response.json();
          setTotalExposure(paresData.data.totalExposure)
          setAvailableBalance(paresData.data.availableBalance)
          setBonus(paresData.data.bonus)
          sessionStorage.setItem("balance", JSON.stringify(paresData.data));
        })
        .catch((error) => {
          console.log("", error);
        });
    }
  }

  const handleCloseStack = () => {
    setStackOpen(false);
    setChangePassword(false);
  }

  const handleAccountPage = () => {
    navigate("/accountstatement");
    toggleAll(false);
  }
   const handleSecureAuthPage = () => {
    navigate("/secureauth");
    toggleAll(false);
  }
  const handleLiveCasinoPage = () => {
    navigate("/livecasinoresult");
    toggleAll(false);
  }
  const handleSportBookPage = () => {
    navigate("/sportbookresult");
    toggleAll(false);
  }
  const handleCurrentBetsPage = () => {
    navigate("/currentbets");
    toggleAll(false);
  }
  const handleActivityPage = () => {
    navigate("/report/activity");
    toggleAll(false);
  }

  const lightTheme = () => {
    localStorage.setItem('theme','light');
    setCurrentTheme('light');
    toggleAll(false);
    config.currentTheme = 'light';
    window.location.reload();
  }

  const darkTheme = () =>{
    localStorage.setItem('theme','dark');
    setCurrentTheme('dark');
    toggleAll(false);
    config.currentTheme = 'dark';
    window.location.reload();
  }

  const getMenu = () => {
    return <ul>
    <li></li>
    {/* <li>{config.currentTheme === 'dark' ? <div className="switch-theme day-theme" onClick={lightTheme}><i className="fas fa-moon"></i></div> : <div className="switch-theme night-theme" onClick={darkTheme}><i className="fas fa-sun"></i></div> } </li> */}
    <li><span className='link' onClick={() => handleAccountPage()}>{t('Account Statement')}</span></li>
    <li><span className='link' onClick={() => handleCurrentBetsPage()}>{t('Current Bets')}</span></li>
    <li><span className='link' onClick={() => handleActivityPage()}>{t('Activity Log')}</span></li>
    <li><span className='link' onClick={() => handleLiveCasinoPage()}>{t('Live Casino Bets')}</span></li>
    {/* <li><span className='link' onClick={() => handleSportBookPage()}>{t('SportBook Bets')}</span></li> */}
    <li><span className='link' onClick={() => setStackOpen(true)}>{t('Set Button Value')}</span></li>
    <li><span className='link' onClick={() => setChangePassword(true)}>{t('Change Password')}</span></li>
    <li><span className='link' onClick={() => handleSecureAuthPage()}>{t('Security Auth Verification')}</span></li>
    <li><span className='link' onClick={() => handleLogout(true)}>{t('Logout')}</span></li>
  </ul>
  }



  return (
    <>
      <header className={`main-header ${sessionStorage.getItem('loggedIn') || loggedIn ? 'loggedIn' : ''}`}>
        <div className="header-info d-flex w-100 mobile-header">
          <div className="menu-button-mobile">
          {location.pathname === "/sport" ?<div onClick={()=>setMobileMenu(!isMobileMenuOpen)}>
          <span className="menu-button-bar"></span>
          <span className="menu-button-bar"></span>
          <span className="menu-button-bar"></span>
          </div>
          : <div onClick={()=> navigate('/sport')}><i className="fas fa-home"></i></div>}
          </div>
          <div className="logo">
            <Link to="/sport">
              <img src={localStorage.getItem("logo")} loading="lazy" alt="" />
            </Link>
          </div>
          <div className="header-right">
            <div className="login-form">
              {sessionStorage.getItem('loggedIn') || loggedIn ?
                <div className="header-login-info">
                  <div className='wallet'>
                    <div className="bal">
                      <span>{`${t('pts')} ${availableBalance.toFixed(2)}`} | -{totalExposure.toFixed(2)}</span>
                    </div>
                  </div>
                  <div ref={accordionRef1} className='mobile-user-dropdown'>
                    <ControlledAccordion
                      providerValue={providerValue}>
                      <AccordionItem
                       itemKey="item-1"
                        open={isOpenProfile1}
                        onClick={toggleAccordion1}
                        header={
                          <div className='user'>
                            <span className='icon'><i className='fa fa-user'></i></span>
                            <span className='name'> {JSON.parse(sessionStorage.getItem('userinfo')).name}</span>
                          </div>
                        }>
                        {getMenu()}
                      </AccordionItem>
                    </ControlledAccordion>

                  </div>
                  <SettingPopup className="desktop-hide"/>
                </div> :
                <>
                  <div className="btn-group">
                    <button className='btn' onClick={() => handleMobileLogin()}>{t('login')}</button>
                  </div>
                </>}

            </div>
          </div>
        </div>
        <div className="header-info d-flex w-100">
          <div className="logo">
            <Link to="/sport">
              <img src={localStorage.getItem("logo")} loading="lazy" alt="" />
            </Link>
          </div>
          <div className="header-right">
            <UpcommingFixture />
            <Notification />
            {/* <div className="news-bar">
              <marquee>All-time live casinos, Everyday Live sports, and Famous fantasy games are available on our exchange. Play to win big.</marquee>
              <div className="icon"> <img src="../images/speaker.svg" alt="" /> </div>
            </div> */}
            <div className="login-form">
              {sessionStorage.getItem('loggedIn') || loggedIn ?
                <div className="header-login-info">
                  <div className='wallet'>
                    <div className="icon">
                      <i className="fa fa-wallet"></i>
                    </div>
                    <div className="bal">
                      <span>{`${t('pts')} ${availableBalance.toFixed(2)}`}</span>
                      <span>{`${t('exp')} -${totalExposure.toFixed(2)}`}</span>
                    </div>
                  </div>
                  <div ref={accordionRef2}>
                    <ControlledAccordion
                      providerValue={providerValue}>
                      <AccordionItem
                      itemKey="item-2"
                        open={isOpenProfile2}
                        onClick={toggleAccordion2}
                        header={
                          <div className='user'>
                            <span className='icon'><i className='fa fa-user'></i></span>
                            <span className='name'> {JSON.parse(sessionStorage.getItem('userinfo')).name}</span>
                          </div>
                        }>

                        {getMenu()}
                       
                      </AccordionItem>
                    </ControlledAccordion>

                  </div>
                </div> :
                <>
                  <div className="input-group mobile-hide">
                    <input type="text" placeholder={t('username')} autoComplete="new-username" name="username" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} />
                  </div>
                  <div className="input-group mobile-hide">
                    <input placeholder={t('password')} autoComplete="new-password" name="password" type={showPassword ? "text" : "password"} className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                    <div className="input-group-append">
                      <button type="button" className="btn btn-secondary password-visible" onClick={() => setShowPassword((prev) => !prev)}><i aria-hidden="true" className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i></button>
                    </div>
                  </div>
                  <div className="btn-group mobile-hide">
                    <button className='btn mobile-hide' onClick={() => handleLogin()}>{t('login')}</button>
                    {config.isWhiteLabel ?'' :<button className='btn' onClick={() => demoHandleClick()}>{t('demo')}</button> }
                    {config.currentTheme === 'dark' ? <div className="desktop-hide switch-theme day-theme" onClick={lightTheme}><i className="fas fa-moon"></i></div> : <div className="desktop-hide switch-theme night-theme" onClick={darkTheme}><i className="fas fa-sun"></i></div>}
                  </div>
                  <SettingPopup className="desktop-hide flex" />
                </>}

            </div>
          </div>
        </div>
        <div className='mobile-fixture'>
        <UpcommingFixture />
        </div>
      </header>
      <StackUpdateFixedBox isStackOpen={isStackOpen} handleClose={handleCloseStack} />
      <ChangePassword isStackOpen={changePassword} handleClose={handleCloseStack} isPasswordChange={isPasswordChange} />
    </>
  )
}

export default HeaderMain